<div class="loader {{size}}" 
  [ngClass]="{
    'table-fade': fade && tableMode,
    'screen-fade': fade && !tableMode,
    'table-loader': tableMode,
    'screen-loader': !tableMode
    }">
  <div class="h-100 d-flex flex-wrap justify-content-center align-items-center align-content-center">
    <div class="lds-grid">
        <div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div>
        <p *ngIf="loaderText" [innerText]="loaderText"></p>
    </div>
  </div>
</div>